import type { BuscarPecasRow } from '@core/types';

// O leitor de código de barras USB "digita" o código e manda Enter. Este
// módulo decide quando um resultado de busca é o bip exato de UMA peça — só
// então a tela pode pular o clique e agir sozinha (Venda joga no carrinho).
// A régua é apertada de propósito: melhor exigir um clique a mais do que
// adicionar a peça errada com o cliente no balcão.

/** Normalização espelho da norm_code() do banco: maiúsculas, só A-Z e 0-9. */
export function normCodigo(t: string | null | undefined): string {
  return (t ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

/**
 * O termo buscado é EXATAMENTE um dos códigos da peça? (EAN, barras do
 * fabricante, código do fabricante, OEM ou SKU). Menos de 3 caracteres úteis
 * nunca conta — termo curto é busca por texto, não bip de leitor.
 */
export function codigoBateExato(termo: string, p: BuscarPecasRow): boolean {
  const alvo = normCodigo(termo);
  if (alvo.length < 3) return false;
  return [p.codigo_barras, p.codigo_barras_fabricante, p.codigo_fabrica, p.codigo_oem, p.sku]
    .some((c) => c != null && normCodigo(c) === alvo);
}
